module.exports = __webpack_public_path__ + "static/media/circuit-trails.1af6fb1a.md";